<template>
  <div>
    <WidgetCreateUpdate
      v-if="formAction"
      :id="toUpdate"
      :form-action.sync="formAction"
    />

    <div class="flexben-container" v-if="!formAction">
      <div class="row mb-4">
        <div class="col-12 col-md-6 flexben-page-title">
          <h1>{{ $t("superUpLang.widget.page_title") }}</h1>
        </div>

        <div class="col-12 col-md-6">
          <button
            @click="create"
            class="btn btn-themed px-4 float-left float-md-right my-2"
          >
            {{ $t("superUpLang.widget.create_new") }}
          </button>
        </div>
      </div>

      <div class="container-bg-white">
        <div class="col-12">
          <div class="row p-3">
            <div class="table-responsive scaled-table hover-table">
              <table class="table table-striped">
                <thead>
                <tr>
                  <td>{{ $t("superUpLang.widget.table.header.id") }}</td>
                  <td>{{ $t("superUpLang.widget.table.header.status") }}</td>
                  <td>{{ $t("superUpLang.widget.table.header.type") }}</td>
                  <td>{{ $t("superUpLang.widget.table.header.available_start") }}</td>
                  <td>{{ $t("superUpLang.widget.table.header.available_end") }}</td>
                  <td>{{ $t("superUpLang.widget.table.header.created_at") }}</td>
                  <td>{{ $t("superUpLang.widget.table.header.updated_at") }}</td>
                  <td></td>
                </tr>
                </thead>

                <tbody>
                <tr v-if="items.length === 0">
                  <td></td>
                  <td></td>
                  <td></td>
                  <td class="text-center">{{ $t("superUpLang.widget.no_items") }}</td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>

                <tr
                  v-for="(item, index) in items"
                  :key="index"
                  class="trhover"
                >
                  <td>{{ item.id }}</td>

                  <td>
                      <span
                        class="offer-status my-auto"
                        :class="'offer-status-' + item.status"
                      >
                        {{ $t("flexben.offers.statuses." + item.status) }}
                      </span>
                  </td>

                  <td>{{ item.type }}</td>
                  <td>{{ item.available_start_date }}</td>
                  <td>{{ item.available_end_date }}</td>
                  <td>{{ item.created_at }}</td>
                  <td>{{ item.updated_at }}</td>

                  <td class="action-group text-right">
                    <button
                      type="button"
                      class="btn action-button"
                      @click="update(item.id)"
                    >
                      {{ $t("flexben.general.btn.see_more") }}
                    </button>

                    <button
                      type="button"
                      style="background-color: red!important; color: white!important"
                      class="ml-3 btn action-button btn-danger"
                      @click="deleteItem(item.id)"
                    >
                      {{ $t("flexben.general.btn.delete") }}
                    </button>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>

    <content-loader
      :loader-visible="loading"
      :loader-error="loaderError"
    />
  </div>
</template>

<script>
import WidgetCreateUpdate from "@/superUp-module/resources/views/pages/widget/carousel/WidgetCreateUpdateCarousel.vue";
import HttpWidgetServices from "@/superUp-module/resources/services/httpWidgetServices";

export default {
  name: "Widget",

  components: {
    WidgetCreateUpdate
  },

  data() {
    return {
      formAction: null,
      toUpdate: null,
      loading: false,
      loaderError: false,
      items: []
    };
  },

  methods: {
    update(id) {
      this.formAction = "update";
      this.toUpdate = id;
    },

    deleteItem(id) {
      HttpWidgetServices.deleteWidget(id).then(() => {
        this.setItems();
      });
    },

    create() {
      this.formAction = "create";
      this.toUpdate = null;
    },

    setItems() {
      HttpWidgetServices.getAll().then((response) => {
        this.items = response.data;
      });
    }
  },

  watch: {
    formAction: {
      handler(val) {
        if (val !== null) {
          return;
        }

        this.setItems();
      },
      deep: true
    }
  },

  mounted() {
    this.setItems();
  }
};
</script>
